import React from 'react';

// Secção 1 · Abertura
export const HerancasHero = () => (
  <section
    className="valuare-hero"
    data-testid="herancas-hero"
    style={{
      paddingTop: '150px',
      paddingBottom: '90px',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      position: 'relative'
    }}
  >
    <div className="valuare-hero-content" style={{ maxWidth: '900px', textAlign: 'center' }}>
      <div
        className="valuare-section-label"
        style={{ justifyContent: 'center', textAlign: 'center' }}
        data-testid="herancas-hero-kicker"
      >
        Heranças e Partilhas
      </div>
      <h1
        className="valuare-hero-title"
        style={{ fontSize: '3.2rem', marginBottom: '2rem', marginTop: '0.5rem', lineHeight: '1.2' }}
      >
        Avaliação de imóveis em<br />
        <em>herança indivisa</em>
      </h1>
      <div className="valuare-hero-divider" style={{ margin: '2rem auto' }}></div>
      <p
        className="valuare-hero-subtitle"
        style={{
          fontSize: '1.1875rem',
          maxWidth: '68ch',
          margin: '0 auto',
          lineHeight: '1.7',
          fontWeight: 400,
          textTransform: 'none',
          letterSpacing: '0'
        }}
      >
        Quando um imóvel integra uma herança por partilhar, o valor que lhe é atribuído
        determina quanto cada herdeiro recebe ou compensa. É esse número que decide as tornas,
        que o tribunal escrutina e que, com frequência, trava o processo durante meses.
      </p>
    </div>
  </section>
);
